import { NewsletterIcon } from '@/assets/icons/custom/newsletter.icon';
import { ICardMetricsProps } from '../../interfaces/card-metrics-props.interface';
import { ISingleCardStats } from '../../interfaces/single-card-stats.interface';
import { ContactMeIcon } from '@/assets/icons/custom/contact-me.icon';
import { ENUM_CARD_TYPE } from '@/modules/playground/enums/card-type.enum';
import { cn } from '@/core/utils/cn';
import _ from 'lodash';
import { formatCompactNumber } from '@/core/utils/numbers/format-compact-number';
import CardMetricsPagination from '../Pagination';
import { ExternalIcon } from '@/assets/icons/external.icon';

const CardMetricsList = ({ data, page, limit, setPage, setLimit }: ICardMetricsProps) => {
  return (
    <div className="divide-y divide-secondary">
      <p className="text-sm text-lighter font-medium mb-4">Cards</p>

      {data.data.map((item: ISingleCardStats) => (
        <div key={item.card_id} className="py-4">
          {item.type === 'Email' ? (
            <div className="flex items-center">
              <div className="h-6 w-6 flex-shrink-0">
                <NewsletterIcon />
              </div>
              <div className="ml-3">
                <div className="font-medium text-lighter">Email Subscribers</div>
              </div>
            </div>
          ) : (
            <div className="flex items-center">
              <div>
                {item.type === 'Button' ? (
                  <ContactMeIcon />
                ) : item.type === ENUM_CARD_TYPE.LINK ? (
                  <img className="h-auto w-6 rounded-[10px]" src={item.favicon_url} alt="" />
                ) : item.type === ENUM_CARD_TYPE.POST ? (
                  <img className="h-auto w-14 rounded-[10px]" src={item.thumbnail_url} alt="" />
                ) : null}
              </div>
              <div className={cn(item.type === ENUM_CARD_TYPE.EMBED ? '' : 'ml-3')}>
                {item.type === ENUM_CARD_TYPE.POST ? (
                  <div className="flex items-center gap-x-1.5">
                    <img className="h-auto w-5 rounded-[10px]" src={item.favicon_url} alt="" />
                    <div
                      className="cursor-pointer flex items-center gap-x-2 font-medium text-lighter break-all whitespace-normal max-w-sm overflow-hidden"
                      onClick={() => {
                        window.open(item.url, '_blank');
                      }}
                    >
                      {_.truncate(item.title, {
                        length: 25,
                        omission: '...',
                        separator: ' ',
                      })}{' '}
                      <ExternalIcon />
                    </div>
                  </div>
                ) : (
                  <div
                    className={cn(
                      'flex items-center gap-x-2 font-medium text-lighter break-all whitespace-normal max-w-sm overflow-hidden',
                      item.type === ENUM_CARD_TYPE.LINK ? 'cursor-pointer' : '',
                    )}
                    onClick={() => {
                      if (item.type === ENUM_CARD_TYPE.EMBED) return;
                      window.open(item.url, '_blank');
                    }}
                  >
                    {_.truncate(item.title, {
                      length: 25,
                      omission: '...',
                      separator: ' ',
                    })}{' '}
                    {item.type === ENUM_CARD_TYPE.LINK ? <ExternalIcon /> : null}
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="mt-4">
            <div className="flex items-center justify-between mb-4">
              <span className="text-sm font-medium text-light">Type</span>
              <span className="text-sm font-medium text-light">{_.capitalize(item.type)}</span>
            </div>
            <div className="flex items-center justify-between mb-4">
              <span className="text-sm font-medium text-light">Impressions</span>
              <span className="text-sm font-medium text-light">{formatCompactNumber(item.impressions)}</span>
            </div>
            <div className="flex items-center justify-between mb-4">
              <span className="text-sm font-medium text-light">Reach</span>
              <span className="text-sm font-medium text-light">{formatCompactNumber(item.reach)}</span>
            </div>
            <div className="flex items-center justify-between mb-4">
              <span className="text-sm font-medium text-light">Total Clicks</span>
              <span className="text-sm font-medium text-light">{formatCompactNumber(item.total_clicks)}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-light">Unique Clicks</span>
              <span className="text-sm font-medium text-light">{formatCompactNumber(item.unique_clicks)}</span>
            </div>
          </div>
        </div>
      ))}

      <CardMetricsPagination
        page={page}
        totalPages={data.totalPages}
        limit={limit}
        setPage={setPage}
        setLimit={setLimit}
      />
    </div>
  );
};

export default CardMetricsList;
